import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/reminders`;

const ReminderManager = {
  // Create a new reminder
  async createReminder(userId, bookId) {
    const response = await axios.post(`${BASE_URL}`, {
      userId,
      bookId,
    });
    return response.data;
  },

  // Get all reminders for a specific user
  async getRemindersForUser(userId) {
    const response = await axios.get(`${BASE_URL}/user/${userId}`);
    return response.data;
  },

  // Delete a specific reminder by ID
  async deleteReminder(reminderId) {
    const response = await axios.delete(`${BASE_URL}/${reminderId}`);
    return response.data;
  },

  // Notify all users for a specific book's availability
  async notifyForBook(bookId) {
    const response = await axios.post(`${BASE_URL}/notify/book/${bookId}`);
    return response.data;
  },

  // Notify a specific user for a specific reminder
  async notifyForReminder(reminderId) {
    const response = await axios.post(`${BASE_URL}/notify/reminder/${reminderId}`);
    return response.data;
  },
};

export default ReminderManager;
